<template>
    <button
        class="a-m-back-button m-back-button"
        type="button"
        @click="onClick"
    >
        <svg-icon
            v-if="theme === 'back'"
            original
            name="icons/arrow-left"
            class="m-back-button__icon"
        />
        <svg-icon
            v-else-if="theme === 'home'"
            original
            name="icons/home"
            class="m-back-button__icon-home"
        />
        <svg-icon
            v-else
            original
            name="icons/close-circle"
            class="m-back-button__icon-close"
        />
        {{ text }}
    </button>
</template>

<script>
import {REMOVE_PATH} from "../../../shared/components/map-viewer/constants/map-commands";

export default {
    name: 'AMBackButton',
    props: {
        theme: {
            type: String,
            default: 'close',
            validator: val => ['close', 'back', 'home'].includes(val)
        },
        text: {
            type: String,
            default: 'Back button'
        }
    },
    methods: {
        onClick(e) {
            this.$bus.$emit(REMOVE_PATH, true)
            this.$emit('onClick', e);
        }
    }
}
</script>

<style lang="scss">
@import "a-m-back-button";
</style>